export const NEW_PAYMENT_METHOD = 'NEW_PAYMENT_METHOD'
export const EDIT_PAYMENT_METHOD = 'EDIT_PAYMENT_METHOD'
export const DELETE_PAYMENT_METHOD = 'DELETE_PAYMENT_METHOD'
export const CLEAR_PAYMENT_METHOD = 'CLEAR_PAYMENT_METHOD'
export const STRIPE_CLIENT_SECRET = 'STRIPE_CLIENT_SECRET'



// WEBPACK FOOTER //
// ./src/common/store/PaymentMethod/types.js